export default "__VITE_ASSET__CG$Rl78R__"